import React, { useMemo } from 'react'
import Seo from '../Seo'

const env = (typeof process !== 'undefined' && process.env) || {}

const DEFAULTS = {
  embedUrl: 'https://app.leanit101.com/benjamin',
  embedToken:
    'eyJvcmdhbml6YXRpb25JZCI6MzEsImFnZW50U2x1ZyI6Imluc2lkZS1zZXJ2aWNlLXN1cHBvcnQiLCJ0ZW5hbnRTbHVnIjoiSW5zaWRlIiwiYXNzaXN0YW50TmFtZSI6Ikluc2lkZVByaW1lIOKAkyBTdXBvcnRlIFTDqWNuaWNvIFNlcnZpY2UiLCJncmVldGluZ3MiOnsicHQiOiJPbMOhIHt7Zmlyc3RfbmFtZX19ISBTb3Uge3thc3Npc3RhbnRfbmFtZX19LCBvIGFnZW50ZSBkZSBzdXBvcnRlIGRhIEluc2lkZSBTaXN0ZW1hcy4gQ29tbyBwb3NzbyB0ZSBhanVkYXIgaG9qZT8iLCJlcyI6IsKhSG9sYSB7e2ZpcnN0X25hbWV9fSEgU295IHt7YXNzaXN0YW50X25hbWV9fSwgZWwgYWdlbnRlIGRlIHNvcG9ydGUgZGUgSW5zaWRlIFNpc3RlbWFzLiDCv0VuIHF1w6kgcHVlZG8gYXl1ZGFydGUgaG95PyIsImVuIjoiSGVsbG8ge3tmaXJzdF9uYW1lfX0hIEknbSB7e2Fzc2lzdGFudF9uYW1lfX0sIHRoZSBzdXBwb3J0IGFnZW50IGZyb20gSW5zaWRlIFNpc3RlbWFzLiBIb3cgY2FuIEkgaGVscCB5b3UgdG9kYXk_In0sIm1ldGFkYXRhIjp7ImNoYW5uZWxEZWZhdWx0Ijoid2ViX2VtYmVkIn19.3ba42de48045d7954f06adfd433fb3056422e1608368bb3bc87576584f434c6f',
  agentSlug: 'inside-service-support',
  tenantSlug: 'inside',
  organizationId: '31',
  assistantName: 'InsidePrime – Suporte Técnico Service',
  channel: 'web_embed',
  utmSource: 'leanit101.com',
  utmCampaign: 'inside-preview',
}

const InsidePage = () => {
  const queryParams = useMemo(() => {
    if (typeof window === 'undefined') return new URLSearchParams('')
    return new URLSearchParams(window.location.search || '')
  }, [])

  const embedToken =
    queryParams.get('token') ||
    env.REACT_APP_INSIDE_EMBED_TOKEN ||
    DEFAULTS.embedToken

  const agentSlug =
    queryParams.get('agentSlug') ||
    env.REACT_APP_INSIDE_AGENT_SLUG ||
    DEFAULTS.agentSlug

  const resolvedTenant =
    queryParams.get('tenantSlug') ||
    env.REACT_APP_INSIDE_TENANT_SLUG ||
    DEFAULTS.tenantSlug
  const tenantSlug = resolvedTenant.toString().trim().toLowerCase()

  const orgId =
    queryParams.get('organizationId') ||
    env.REACT_APP_INSIDE_ORGANIZATION_ID ||
    DEFAULTS.organizationId

  const assistantName =
    queryParams.get('assistantName') ||
    env.REACT_APP_INSIDE_ASSISTANT_NAME ||
    DEFAULTS.assistantName

  const channel = queryParams.get('channel') || DEFAULTS.channel
  const utmSource = queryParams.get('utm_source') || DEFAULTS.utmSource
  const utmCampaign = queryParams.get('utm_campaign') || DEFAULTS.utmCampaign

  const iframeSrc = useMemo(() => {
    const params = new URLSearchParams()
    if (embedToken) {
      params.set('token', embedToken)
    }
    params.set('agentSlug', agentSlug)
    params.set('tenantSlug', tenantSlug)
    params.set('organizationId', orgId)
    params.set('assistantName', assistantName)
    params.set('channel', channel)
    if (utmSource) params.set('utm_source', utmSource)
    if (utmCampaign) params.set('utm_campaign', utmCampaign)
    params.set('meta.source', 'inside-preview')
    params.set('meta.partner', 'inside-sistemas')

    const baseUrl = env.REACT_APP_INSIDE_EMBED_URL || DEFAULTS.embedUrl
    return `${baseUrl}?${params.toString()}`
  }, [
    agentSlug,
    assistantName,
    channel,
    embedToken,
    orgId,
    tenantSlug,
    utmCampaign,
    utmSource,
  ])

  return (
    <section className="relative flex flex-col w-full min-h-screen overflow-hidden bg-[#050913] text-white">
      <Seo
        title="InsidePrime Preview | Lean it 101"
        description="Private preview route for Inside Sistemas support assistant."
        path="/inside"
        noindex
      />
      <div className="absolute inset-0 -z-10">
        <div className="absolute inset-0 bg-gradient-to-b from-[#070c1b] via-[#050913] to-[#050913]" />
        <div
          className="absolute -top-24 left-1/2 -translate-x-1/2 w-[620px] h-[620px] rounded-full opacity-30"
          style={{
            background:
              'radial-gradient(50% 50% at 50% 50%, rgba(25,162,207,0.5) 0%, rgba(25,162,207,0) 60%)',
            filter: 'blur(48px)',
          }}
        />
        <div
          className="absolute bottom-[-260px] right-[-120px] w-[560px] h-[560px] rounded-full opacity-20"
          style={{
            background:
              'radial-gradient(50% 50% at 50% 50%, rgba(248,129,22,0.4) 0%, rgba(248,129,22,0) 65%)',
            filter: 'blur(40px)',
          }}
        />
        <div
          className="absolute inset-0 opacity-[0.08]"
          style={{
            backgroundImage:
              'linear-gradient(to right, rgba(255,255,255,0.07) 1px, transparent 1px), linear-gradient(to bottom, rgba(255,255,255,0.07) 1px, transparent 1px)',
            backgroundSize: '28px 28px',
          }}
        />
      </div>

      <div className="w-full max-w-5xl mx-auto px-4 py-12 md:py-16 space-y-8">
        <header className="text-center space-y-4">
          <p className="text-xs uppercase tracking-[0.4em] text-slate-400">
            Inside Sistemas
          </p>
          <h1 className="text-3xl md:text-4xl font-semibold">
            InsidePrime – Suporte Técnico Service
          </h1>
          <p className="text-base md:text-lg text-slate-200">
            Ambiente exclusivo para o time da Inside avaliar o comportamento do
            assistente antes da publicação oficial. As conversas já usam o
            prompt, ferramentas e base de conhecimento configurados para o
            Service.
          </p>
        </header>

        <div className="w-full bg-slate-900/50 border border-slate-800 rounded-2xl shadow-2xl">
          <div className="relative w-full h-[460px] md:h-[520px]">
            <iframe
              title="InsidePrime – agente de suporte"
              src={iframeSrc}
              allow="clipboard-read; clipboard-write"
              className="absolute inset-0 w-full h-full rounded-2xl"
              style={{ background: 'transparent' }}
            />
          </div>
        </div>

        <div className="grid gap-4 md:grid-cols-3">
          <div className="bg-white/5 border border-white/10 rounded-xl p-4 backdrop-blur-sm">
            <h2 className="text-lg font-semibold mb-2">
              Compartilhe com o time
            </h2>
            <p className="text-sm text-slate-200">
              Use o link{' '}
              <code className="text-xs break-all text-amber-200">
                https://leanit101.com/inside
              </code>{' '}
              para validar fluxos com suporte, produto e liderança.
            </p>
          </div>
          <div className="bg-white/5 border border-white/10 rounded-xl p-4 backdrop-blur-sm">
            <h2 className="text-lg font-semibold mb-2">Idiomas ativados</h2>
            <p className="text-sm text-slate-200">
              Cumprimentos e respostas localizadas em português, espanhol e
              inglês — os três estão no token.
            </p>
          </div>
          <div className="bg-white/5 border border-white/10 rounded-xl p-4 backdrop-blur-sm">
            <h2 className="text-lg font-semibold mb-2">Personalização</h2>
            <p className="text-sm text-slate-200">
              O agente usa o comando específico do Service e envia eventos com o
              organizationId 31.
            </p>
          </div>
        </div>
      </div>
    </section>
  )
}

export default InsidePage
